import {useCallback, useEffect, useState} from "react";
import {useGlobalStore} from "../store/hooks/useStore";

const key = 'hideLeaveProductReviewByGroups'
export const useProductReviews = () => {
  const globalStore = useGlobalStore()
  const groups = globalStore.customSitePreferences[key] as string[]
  const [hideLeaveProductReviewByGroups, setHideLeaveProductReviewByGroups] = useState<string[]>(groups)

  const isGroupRestricted = useCallback((
    group: string) => {
      return !!hideLeaveProductReviewByGroups?.find((groupName) => {
        return group.trim() == groupName.trim()
      })
    },
    [hideLeaveProductReviewByGroups],
  )

  useEffect(() => {
    setHideLeaveProductReviewByGroups(groups)
  }, [globalStore.customSitePreferences])

  return {
    hideLeaveProductReviewByGroups,
    isGroupRestricted,
  }
}
